import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, CardHeader, CardMedia, Divider, Grid } from '@mui/material';
import PlanConfirmDialog from './common/PlanConfirmDialog';
import parse, { domToReact } from 'html-react-parser'
import { LoginInfo } from '../App';

const PlanMini = (props) => {
    // 翻訳
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate()
    const location = useLocation()
	const [terms,setTerms] = useState("")

	useEffect(() => {

	},[location.pathname])

    return(
    <Grid xs={12} sm={12} md={6} lg={4} xl={3} xxl={3} className='mb-3'>
        <Card sx={{ maxWidth: 300 }} style={{cursor:"pointer"}} onClick={() => {navigate("/user/"+(props.data.plan_display_id !== "" ? props.data.plan_display_id : props.data.plan_user_id)+"/plans")}}>
            <CardHeader title={<><Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+props.data.user_id+".jpg?"+loginInfo.hash} style={{width:"50px",height:"auto",borderRadius:"50%",border:"5px solid #FFFFFF"}} /> {props.data.user_name.substring(0,14)}</>} />
            <CardMedia component={"img"} image={(props.data.plan_id === undefined ? "/img/plan.webp" : ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/plan/"+props.data.plan_id+".webp?"+props.data.update_datetime)} height={150} />
            <CardContent>
                {props.data.name}
            </CardContent>
        </Card>
    </Grid>
    )
}

export default PlanMini;
